import { PurchaseLimitType } from 'shared/core/constants/compliance';
export var MILLIGRAMS = 'MILLIGRAMS';
export var MILLILITERS = 'MILLILITERS';
export var GRAMS = 'GRAMS';
export var MILLIGRAMS_PER_GRAM = 1000;
export var MILLILITERS_PER_OZ = 29.5735;
export var GRAMS_PER_OUNCE = 28;
export var FLOWER_TYPES = [
    'Flower',
    'Pre-Rolls'
];
export var CONCENTRATE_TYPES = [
    'Concentrate',
    'Vaporizers'
];
export var EDIBLE_TYPES = [
    'Edible'
];
export var TINCTURE_TYPES = [
    'Tincture'
];
export var TOPICAL_TYPES = [
    'Topicals'
];
export var WEIGHTED_TYPES = [
    'Flower',
    'Pre-Rolls',
    'Concentrate',
    'Vaporizers'
];
/**
 * Storefront categories that can hold inhalable-form products. A jurisdiction's combined
 * inhalable bucket only meters products from these categories, so a product from a
 * non-inhalable category (for example an oral edible) that merely carries a shared subcategory
 * tag cannot consume the inhalation allowance.
 */ export var COMBINED_INHALABLE_TYPES = [
    'Pre-Rolls',
    'Concentrate',
    'Vaporizers'
];
/** Purchase-limit type overrides that the enforcement engine can classify safely. */ export var SUPPORTED_PURCHASE_LIMIT_TYPE_OVERRIDES = Object.values(PurchaseLimitType);
